
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns2eec1a1c71b221177b41da9ad26c29e4en from './en.yaml'
            i18n.addResourceBundle('en', '2eec1a1c71b221177b41da9ad26c29e4', flattenObject(ns2eec1a1c71b221177b41da9ad26c29e4en), true, true);
        
        export default '2eec1a1c71b221177b41da9ad26c29e4';
    